module.exports = __webpack_public_path__ + "8418859e8f3d5f44ff8741d50c9d0e6f.pdf";